import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './styles.css';
import { Well } from 'react-bootstrap';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import fetch from '../../core/fetch';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';

class MyMessages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: this.props.userData,
            login: this.props.login,
            topics: [],
            all_topics: [],
            urzednik_topics: [],
            access: false,
            district: null,
            colors: 'normal',
            sourceStyle: layoutColorStyle,
            style: {},
        }
    }

    componentDidMount() {
        // Pobieramy wiadopmosci dla konkretnego uzytkownika
        let url = `${process.env.API_URL}/invest/getTopics/${this.state.user.ID}`;
        // let url = `http://localhost:8000/api/v1.0/invest/getTopics/${this.state.user.ID}`;
        fetch(url)
        .then(r => r.json())
        .then(resp => {
            this.setState({
                topics: resp.topics
            });
        })

        // Pobieram informacje na temat gminy na podstawie ID uzytkownika
        // Zwraca także access, ktory odpowiada za wyświetlanie sekcji z wszystkimi wiadomosciami
        // urzednika
        let url3 = `${process.env.API_URL}/invest/urzednikGetTopics/${this.state.user.ID}`;
        // let url3 = `http://localhost:8000/api/v1.0/invest/urzednikGetTopics/${this.state.user.ID}`;
        fetch(url3)
        .then(r => r.json())
        .then(resp => {
            this.setState({
                access: resp.access,
                district: resp.district
            });
        })

        // Pobieram liste wszystkich wiadmosci 
        // Następnie mapujemy wiadomosci, ktore sa dla okreslonej gminy
        let url2 = `${process.env.API_URL}/invest/getTopics`;
        // let url2 = `http://localhost:8000/api/v1.0/invest/getTopics`;
        fetch(url2)
        .then(r => r.json())
        .then(resp => {
            this.setState({
                all_topics: resp.topics
            });

            let arr = [];
            this.state.all_topics.map((v) => {
                if(v.teryt == this.state.district.teryt) {
                    arr.push(v)
                }
            })
            this.setState({
                urzednik_topics: arr
            })
        })
        const colors = getThemeFromLocalStorage();
        let sourceStyle = layoutColorStyle;
        let style = {
        color: sourceStyle[colors].color,
        display: 'block',
        };
        if (colors !== 'normal') {
        sourceStyle = headerStyle;
        style = {
            color: sourceStyle[colors].color,
            backgroundColor: sourceStyle[colors].backgroundColor,
            display: 'block',
        };
        }
        this.setState({ colors, sourceStyle, style });
    }

    render() {
        return(
            <div>
                <div className={s.delContainer} style={this.state.style}>
                    <div className={s.delTitle} >Moje zapytania ofertowe</div>
                    <GrayPanel title="Moje zapytania">
                    {this.state.topics.length > 0 ?
                        (<table className="table">
                            <thead>
                            <tr>
                                <th>Temat</th>
                                <th>Data utworzenia</th>
                                <th>#</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.topics.map((v, i) => {
                                let date = new Date(v.created);
                                date = (date.getDate() > 10 ? date.getDate() : '0' + date.getDate())  + '.' + (date.getMonth() > 10 ? date.getMonth() : '0' + (date.getMonth()+1))  + '.' + date.getFullYear() + ' ' + (date.getHours() > 10 ? date.getHours() : '0' + date.getHours()) + ':' + (date.getMinutes() > 10 ? date.getMinutes() : '0' + date.getMinutes());
                                return(
                                <tr key={i}>
                                    <td>{v.topic}</td>
                                    <td>{date}</td>
                                    <td><a href={"/panel/" + this.state.login + "/zapytanie/" + v.id}>Szczegóły</a></td>
                                </tr>
                                ) 
                            })}
                            
                            </tbody>
                        </table>)
                     : <div>Nie wysłałeś żadnych zapytań.</div>}
                    </GrayPanel>
                    {this.state.access ? <div>
                        <GrayPanel title="Lista zapytań">
                            {this.state.topics.length > 0 ?
                                (<table className="table">
                                    <thead>
                                    <tr>
                                        <th>Temat</th>
                                        <th>Data utworzenia</th>
                                        <th>#</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.urzednik_topics.map((v, i) => {
                                        let date = new Date(v.created);
                                        date = (date.getDay() > 10 ? date.getDay() : '0' + date.getDay())  + '.' + (date.getMonth() > 10 ? date.getMonth() : '0' + date.getMonth())  + '.' + date.getFullYear() + ' ' + (date.getHours() > 10 ? date.getHours() : '0' + date.getHours()) + ':' + (date.getMinutes() > 10 ? date.getMinutes() : '0' + date.getMinutes());
                                        return(
                                        <tr key={i}>
                                            <td>{v.topic}</td>
                                            <td>{date}</td>
                                            <td><a href={"/panel/" + this.state.login + "/zapytanie/" + v.id}>Szczegóły</a></td>
                                        </tr>
                                        ) 
                                    })}
                                    
                                    </tbody>
                                </table>)
                            : <div>Nie wysłano żadnych zapytań</div>}
                        </GrayPanel>
                    </div> : null}
                    
                    
                </div>
            </div>
        )
    }
}

export default withStyles(s)(MyMessages);


// WEBPACK FOOTER //
// src/routes/MyMessages/index.js